import { ApiClient } from '@k2/common/backend/api-client';

export class ServiceExceptionEndpoint {
  constructor(private api: ApiClient) {

  }

  getFormCreateServiceException = (assignmentServiceInstanceId: number) => {
    return this.api.get(`/assignment-service-instance/${assignmentServiceInstanceId}/service-exception/form-create`);
  };

  createServiceException = (assignmentServiceInstanceId: number, data: any) => {
    return this.api.post(`/assignment-service-instance/${assignmentServiceInstanceId}/service-exception`, data);
  }

  getFormUpdateServiceException = (serviceExceptionId: number) => {
    return this.api.get(`/service-exception/${serviceExceptionId}/form-update`);
  };

  updateServiceException = (serviceExceptionId: number, data: any) => {
    return this.api.patch(`/service-exception/${serviceExceptionId}`, data);
  }

  deleteServiceException = (serviceExceptionId: number) => {
    return this.api.delete(`/service-exception/${serviceExceptionId}`);
  };
}
